import { downloadFile } from 'utils/download';
import Preview from '@xylink/xy-editor/dist/preview';
// import Preview from './preview.js';
import { IEnclosure } from '@xylink/xy-editor/dist/type/index';
import '@xylink/xy-editor/dist/css/preview.css';
// import './css/preview.css';
import cn from 'classnames';
import style from './index.module.scss';
interface IDetail {
  id: string;
  content: string;
  intro?: string;
  viewCount?: number;
  releaseTime?: string;
  author?: string;
  enclosureList?: IEnclosure;
}
interface IProps {
  detail: IDetail;
  classNames?: string;
  pdfPreview?: boolean;
  isImgView?: boolean;
}
export default function Home(props: IProps) {
  const { classNames, detail, pdfPreview = false, isImgView = true } = props;
  const { id, intro, viewCount, content, releaseTime, enclosureList, author } = detail;

  const onDownload = async (item: { resourceId: string; resourceName: string }) => {
    downloadFile(id, item.resourceId, item.resourceName);
  };

  const onPreviewPdf = async (item: { resourceId: string; resourceName: string }) => {
    const url = await downloadFile(id, item.resourceId, item.resourceName, true);
    console.log(url);
    if (typeof url === 'string') {
      window.open(url, '_blanl');
    }
  };

  return (
    <Preview
      isWebsite={true}
      className={cn(style.container, !!classNames && classNames)}
      viewCount={viewCount}
      author={author}
      enclosure={
        enclosureList
          ? {
              enclosureList,
              onDownloadEnclosure: onDownload,
              onPreviewPdf: pdfPreview ? onPreviewPdf : undefined,
            }
          : undefined
      }
      releaseTime={releaseTime}
      intro={intro}
      content={content}
      isImgView={isImgView}
    />
  );
}
